import { Dialog, Divider } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import React from 'react';

export const initialRadio = [
  {
    id: 1,
    label: 'Create and update searches for all luminaire types',
    value: '1',
  },
  {
    id: 2,
    label:
      'Create searches for new luminaire types only. Do not update existing searches',
    value: '2',
  },
  {
    id: 3,
    label:
      'Manually select luminaire types for which a search is to be created or updated',
    value: '3',
  },
];

export const mapArrays = checkboxes => {
  const tempArr = [];
  const responseArr = [];
  checkboxes.map(item => {
    if (item.isChecked) tempArr.push(item.name);
    if (item.isChecked && item.haveResponse) responseArr.push(item.name);
  });
  return {
    secondStepArr: tempArr,
    thirdStepArr: responseArr,
  };
};

export const handleRadioChange = (value, Set) => {
  Set(value.target.value);
};

export const handleCheckboxChange = (index, checked, Set) => {
  Set(isChecked => {
    return isChecked.map((item, idx) => {
      if (idx === index) return { ...item, isChecked: checked };
      return item;
    });
  });
};

export const handleSelectAll = (checked, Set) => {
  Set(isChecked => {
    return isChecked.map(item => {
      return { ...item, isChecked: checked };
    });
  });
};

export const SubmitModal = ({ confirm, modalArr, handleClose, modalOpen }) => {
  return (
    <Dialog
      classes={{
        paper: 'e-zindex--max bc-gray',
      }}
      maxWidth="sm"
      open={modalOpen}
      onClose={handleClose}
    >
      <h4 className="t-primary-20 t-weight--b t-align-c u-mrg-top-50 u-mrg-bot-20">
        Confirm changes to luminaire type(s)
      </h4>
      <Divider />
      <DialogContent>
        <div className="u-mrg-bot-20">
          <div className="t-primary-16 u-mrg-bot-10 u-mrg-top-10">
            List all affected luminaire types included in import:
          </div>
          {modalArr
            ? modalArr.map(item => {
                return (
                  <div
                    key={item}
                    className="t-weight-b u-pad-l-60 t-primary-14 u-pad-r-25 u-pad-l-25 u-mrg-bot-5"
                  >
                    {item}
                  </div>
                );
              })
            : null}
        </div>
        {/* <Divider /> */}
        <p className="t-primary-14 c-blue-2-light u-mrg-top-10">
          Note that modifying Search Requirements for existing Searches will
          result in all current Luminaire Responses from suppliers for the
          Search being deleted, and the suppliers will have to resubmit
          Responses confirming that their Luminaires conform to the new
          Requirements. If you do not want to lose current Luminaire Responses
          for these Searches, press EXCLUDE FROM IMPORT.
        </p>
      </DialogContent>

      <DialogActions>
        <Button
          classes={{
            root: 't-primary-16 c-blue-2-light t-weight-b',
          }}
          onClick={handleClose}
        >
          EXCLUDE FROM IMPORT
        </Button>
        <Button
          classes={{
            root: 't-primary-16 c-s-blue',
          }}
          onClick={confirm}
          variant="contained"
          color="primary"
        >
          CONFIRM CHANGES
        </Button>
      </DialogActions>
    </Dialog>
  );
};
